export default __webpack_public_path__ + "static/media/joao.9d1f22a6.jpg";